import { ErrorMessages, ProductType, ShelfOrganizerValidation } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addDrawerOrganizer = ({ coreApi, props }: BehaviorParameters) => {
  const shelfOrganizerValidation = new ShelfOrganizerValidation(
    coreApi,
    ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER,
    [
      ProductType.PLATSA_SHELF,
      ProductType.PLATSA_FRAME,
      ProductType.PLATSA_OPEN_FRAME_SHELVES,
      ProductType.PLATSA_OPEN_FRAME_HANGING,
      ProductType.PLATSA_OPEN_FRAME_SHOES
    ]
  );

  // Some organizers can be placed on both shelves and drawers but here we temporary disable
  // snapping to shelves and frames since this is called from drawers section in menu
  coreApi.core.addValidation(shelfOrganizerValidation);

  const placementResult = coreApi.products.add(props.coreProductId, props.position);
  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
      ? ErrorMessages.NoFramesInScene
      : ErrorMessages.ItemWontFit;
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  }
  coreApi.core.removeValidation(shelfOrganizerValidation);
};

export { addDrawerOrganizer };
